import axios from "axios";
const BASE_URL_MAP = {
  dev: "https://course-selection-test.inner.youdao.com",
  test: "https://course-selection-test.inner.youdao.com",
  staging: "https://course-selection-pre.inner.youdao.com",
  prod: "https://course-selection.youdao.com",
};


const ADDRESS_URL_MAP = {
  dev: "https://course-selection-internal-test.inner.youdao.com",
  test: "https://course-selection-internal-test.inner.youdao.com",
  staging: "https://course-selection-internal-pre.inner.youdao.com",
  prod: "https://course-selection-internal.inner.youdao.com",
};

export const ADDRESS_TO_B_URL =
ADDRESS_URL_MAP[(process.env.APP_ENV || "dev") as keyof typeof BASE_URL_MAP];


export const BASE_URL =
  BASE_URL_MAP[(process.env.APP_ENV || "dev") as keyof typeof BASE_URL_MAP];

console.log("BASE_URL", BASE_URL);

export const API_COURSE_SERVER = {
  dev: "https://ke.youdao.com/",
  test: "https://ke.youdao.com/",
  staging: "https://ke.youdao.com/",
  prod: "https://ke.youdao.com/",
}[process.env.APP_ENV || "dev"];

export const axiosReq = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  withCredentials: true,
});

// 请求拦截器
axiosReq.interceptors.request.use(
  (config) => {
    //  公共的请求参数
    const commonParams = {};
    config.params = { ...config.params, ...commonParams };
    return config;
  },
  (error) => Promise.reject(error)
);

axiosReq.interceptors.response.use(
  (res) => res.data,
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosReq;
